<div class="registerForm">
    <app-formular [formBuilderInput]="modelInput" [groupName]="'REGISTER'" [formular]="formular" (action)="action($event)" [groupName]="groupName"></app-formular>
    <div style ="padding-left: 15px;">
        <div style="display: flex;">
            <mat-checkbox color="primary" class="formItem formCheckbox" [formControl]="modelInput.controls.AcceptTermOfUse">
            </mat-checkbox>
            <div style="display: flex; padding-left: 5px; padding-top: 1px;" [innerHTML]="getAcceptTermOfUse()" (click)="download($event)"></div>
        </div>
        <div style="display: flex;">
            <mat-checkbox color="primary" class="formItem formCheckbox" [formControl]="modelInput.controls.ReadDataProtection">
            </mat-checkbox>
            <div style="display: flex; padding-left: 5px; padding-top: 1px;" [innerHTML]="getReadDataProtection()" (click)="download($event)"></div>
        </div>
    </div>
    <div *ngIf="enabledRecaptcha && siteKey != ''" style="text-align: -webkit-center;">
        <re-captcha [siteKey]="siteKey" (resolved)="resolved($event)">
        </re-captcha>
    </div>
    <br>

    <button mat-raised-button color="primary" (click)="register()" [disabled]="!isRegisterEnabled()">{{'CREATEACCOUNT' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>

    <!-- <p class="formItem" (click)="download()" style="cursor:pointer; color:blue; text-align: center; padding-top: 10px;">
        {{"LinkTerms" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Group"}}</p> -->

</div>